// Helper Function for handle All Display Values
export const getDisplayValue = (value) => {
  return (value === null || value === undefined || String(value).trim() === "")
    ? "N/A"
    : value;
};